'use strict';

import React, { Component, PropTypes as reactPropTypes } from 'react';
import _require from 'react/lib/ReactInputSelection';
import InputMask from 'inputmask-core';

function _objectWithoutProperties(obj, keys) {
    var target = {};
    for (var i in obj) {
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i))
            continue; target[i] = obj[i];
    }
    return target;
}

var getSelection = _require.getSelection;
var setSelection = _require.setSelection;

var KEYCODE_Z = 90;
var KEYCODE_Y = 89;

function isUndo(e) {
    return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Y : KEYCODE_Z);
}

function isRedo(e) {
    return (e.ctrlKey || e.metaKey) && e.keyCode === (e.shiftKey ? KEYCODE_Z : KEYCODE_Y);
}

export default class CustomMaskedInput extends Component {
    static displayName = 'CustomMaskedInput';

    static propTypes = {
        mask: React.PropTypes.string.isRequired,
        formatCharacters: React.PropTypes.object,
        placeholderChar: React.PropTypes.string
    };

    static contextTypes = {
        maskedInoutUnsupported: React.PropTypes.bool,
        isAndroid: React.PropTypes.bool
    }

    static defaultProps = {
        value: ''
    };

    constructor(props, ...rest) {
        super(props, ...rest);
        this.state = {
            previousSelection: {start: 0, end: 0}
        };
        this.previousInputValue = "";
        this.useKeyCode229ForBack = false;
    }

    componentWillMount () {
        var options = {
            pattern: this.props.mask,
            value: this.props.value,
            formatCharacters: this.props.formatCharacters
        };
        if (this.props.placeholderChar) {
            options.placeholderChar = this.props.placeholderChar;
        }
        this.mask = new InputMask(options);

        //Clear ssnNine at going back or refresh;
        const { hidableMaskedInput } = this.props;
        hidableMaskedInput && this.mask.setValue('');
    }

    componentWillReceiveProps (nextProps) {
        if (this.props.value !== nextProps.value) {
            this.mask.setValue(nextProps.value);
        }
        if (this.props.mask !== nextProps.mask) {
            this.mask.setPattern(nextProps.mask, { value: this.mask.getRawValue() });
        }
    }

    componentDidUpdate (prevProps) {
        this._updateMaskSelection();

        if (this.state.previousSelection.start < this.mask.selection.start) {
            if(this.props.hidableMaskedInput) {
              this.mask.selection = this.state.previousSelection;
            } else if (this.state.previousSelection.start < prevProps.value.length) {
              this.mask.selection = this.state.previousSelection;
            }

            this._updateInputSelection();
        }
    }

    _updateMaskSelection () {
        this.mask.selection = getSelection(this.input);
    }

    _updateInputSelection () {
        setSelection(this.input, this.mask.selection);
        this.setState({
            previousSelection: this.mask.selection
        });
    }

    _onChange (e) {
        var maskValue = this.mask.getValue();

        if (e.target.value !== maskValue) {
            // Cut or delete operations will have shortened the value
            if (e.target.value.length < maskValue.length) {
                var sizeDiff = maskValue.length - e.target.value.length;
                this._updateMaskSelection();
                this.mask.selection.end = this.mask.selection.start + sizeDiff;
                this.mask.backspace();
            }
            var value = this._getDisplayValue();
            e.target.value = value;
            e.target.value = this._setTargetValForSsn(e.target.value);
            if (value) {
                this._updateInputSelection();
            }
        }
        if (this.props.onChange) {
            this.props.onChange(e);
        }
    }

    _onKeyDown (e) {
        if(e.timeStamp - e.PREVIOUS_EVENT_TIMESTAMP < 15) {
            e.PREVIOUS_EVENT_TIMESTAMP = e.timeStamp;
            return
        }
        e.PREVIOUS_EVENT_TIMESTAMP = e.timeStamp;

        if(!this.useKeyCode229ForBack && (e.which || e.keycode) !== 229 && (e.which || e.keycode) !== 8) {
            this.useKeyCode229ForBack = true;
        }

        if (isUndo(e)) {
            e.preventDefault();
            if (this.mask.undo()) {
                e.target.value = this._getDisplayValue();
                e.target.value = this._setTargetValForSsn(e.target.value);
                this._updateInputSelection();
                this.props.onChange(e);
            }
            return;
        } else if (isRedo(e)) {
            e.preventDefault();
            if (this.mask.redo()) {
                e.target.value = this._getDisplayValue();
                e.target.value = this._setTargetValForSsn(e.target.value);
                this._updateInputSelection();
                this.props.onChange(e);
            }
            return;
        }



        const isBackSpace = e.key == "Unidentified" && this.useKeyCode229ForBack && (e.which || e.keycode) === 229;

        if (!this.context.maskedInoutUnsupported && ( (e.key === 'Backspace') || (isBackSpace) )) {
            e.preventDefault();
            this._updateMaskSelection();
            if (this.mask.backspace()) {
                var value = this._getDisplayValue();
                e.target.value = value;
                e.target.value = this._setTargetValForSsn(e.target.value);
                if (value) {
                    this._updateInputSelection();
                }
                this.props.onChange(e);
            }
        }
    }

    _onKeyPress (e) {
        if (e.metaKey || e.altKey || e.ctrlKey || ((e.key || e.data) === 'Enter')) {
            return;
        }

        e.preventDefault();
        this._updateMaskSelection();
        if (this.mask.input(e.key || e.data)) {
            e.target.value = this.mask.getValue();
            this._updateInputSelection();
            this.props.onChange(e);
        }
    }

    _onPaste (e) {
        e.preventDefault();
        this._updateMaskSelection();
        this._updateInputSelection();
        // getData value needed for IE also works in FF & Chrome
        if (this.mask.paste(e.clipboardData.getData('Text'))) {
            e.target.value = this.mask.getValue();
            // Timeout needed for IE
            setTimeout(this._updateInputSelection.bind(this), 0);
            this.props.onChange(e);
        }
    }

    _getDisplayValue () {
        // var value = this.mask.getValue();
        var value = this.mask.getValue().trim();
        var lastIdx = value.length - 1;

        // Adding a whitespace according to format
        if (
            lastIdx === this.mask.selection.start-1 &&
            lastIdx < this.mask.pattern.source.length - 1 &&
            this.mask.pattern.source[lastIdx+1] === ' '
        ) {
            value += ' ';
        }

        return this._toggleHide(value === this.mask.emptyValue ? '' : value);
    }

    _setTargetValForSsn = (currentTargetValue) => {
      const { hidableMaskedInput } = this.props;
      const inputValue = this.mask.getValue();
      return hidableMaskedInput ? inputValue && inputValue.trim() : currentTargetValue;
    }

    _toggleHide(value) {
      if(!value || !this.props.hideSSN) {
        return value;
      }
      const hiddenValue = value.replace(/[0-9]/g, "•");
      return hiddenValue;
    }

    /* This is the fallback for Android broswers that does not fire onBeforeInput */
    _onInputShim(e) {

        this._updateMaskSelection();
        e.preventDefault();
        const inputValue = e && e.target && e.target.value;
        if(!inputValue){ return }

        var previousNurmicValue = this._getDisplayValue().replace(/\D/g,'');
        var numericInputValue = inputValue.replace(/\D/g,'');

        /* For some android versions, backspace is not working this is the work around*/
        if(this.context.maskedInoutUnsupported) {
            if((previousNurmicValue.length == numericInputValue.length) || (previousNurmicValue.length-1 == numericInputValue.length)) {
                this.mask.setValue(numericInputValue);
                e.preventDefault();
                e.target.value = this._getDisplayValue();
                this._updateInputSelection();
                this.props.onChange(e);
                return;
            }
        }

        const lastChar = numericInputValue.slice(-1);
        if(this.props.placeholderChar !== "_" && this._getDisplayValue().length >= this.mask.pattern.length -1) {
            e.target.value = this._getDisplayValue()
            return;
        }

        if (this.mask.input(lastChar)) {
            e.target.value = this._getDisplayValue();
            this._updateInputSelection();
            this.props.onChange(e);
            this.previousInputValue = e.target.value;
        }

    }

    render () {
        const { hidableMaskedInput } = this.props;
        var _props = this.props;
        var mask = _props.mask;
        var formatCharacters = _props.formatCharacters;
        var size = _props.size;
        var placeholder = _props.placeholder;
        var errorId = _props.id + '-help';

        var props = _objectWithoutProperties(_props, ['mask', 'formatCharacters', 'size', 'placeholder']);

        var patternLength = this.mask.pattern.length;

        var isServer = typeof window === "undefined" && typeof document === "undefined";
        var noJsHideInput = hidableMaskedInput && isServer ? {type:"password"} : {type:"tel"};

        var isAndroid = this.context.isAndroid == null ? true : this.context.isAndroid;
        var androidOnInputShim = isAndroid ? {
            onInput: this::this._onInputShim
        } : {}

        return (
            <input
                {...props}
                {...noJsHideInput}
                ref={(r) => {return this.input = r;}}
                maxLength = {patternLength}
                { ...androidOnInputShim }

                onChange={this::this._onChange}
                onKeyDown={this::this._onKeyDown}
                onBeforeInput={this::this._onKeyPress}
                onPaste={this::this._onPaste}
                placeholder={placeholder || this.mask.emptyValue}
                size={size || patternLength}
                value={this._getDisplayValue()}
                aria-describedby={errorId}
            />
        );
    }
};



/** WEBPACK FOOTER **
 ** ./src/types/card/CustomMaskedInput.jsx
 **/